import {isReactCodeViewHeaderEnabled} from '@github-ui/code-view-header/is-enabled'
import type {BranchAndTagCountData} from '@github-ui/code-view-shared/contexts/BranchAndTagContext'
import type {RecentlyTouchedBranches} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import {isReactCodeViewSidebarEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {latestCommitQuery} from '../queries/latest-commit-query'
import {sidebarAboutQuery} from '../queries/sidebar-about-query'
import {treeCommitInfoQuery} from '../queries/tree-commit-info-query'

export const codeViewRepoRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewRepoRoute', {
  path: '/:owner/:repo',
  index: true,
  queries: [
    mainQuery<DataRouterFileOverviewPayload>(),
    railsPartialQuery({
      partialName: 'Header',
      queryDeps: ({pathname}) => {
        return {pathname: `${pathname}/partials/header`}
      },
      enabled: () => !isReactCodeViewHeaderEnabled(),
    }),
    railsPartialQuery({
      partialName: 'Sidebar',
      queryDeps: ({pathname}) => {
        return {pathname: `${pathname}/partials/sidebar`}
      },
      enabled: () => !isReactCodeViewSidebarEnabled(),
    }),
    sidebarAboutQuery,
    latestCommitQuery,
    treeCommitInfoQuery,
    {
      queryName: 'recentlyTouchedBranches',
      queryDeps: ({params}) => ({pathname: `/${params.owner}/${params.repo}/recently-touched-branches`}),
      queryFn: async queryKey => queryFnFetch<RecentlyTouchedBranches>(queryKey),
      type: QueryRouteQueryType.Deferred,
    },
    {
      queryName: 'branchAndTagCount',
      queryDeps: ({params}) => ({pathname: `/${params.owner}/${params.repo}/branch-and-tag-count`}),
      queryFn: async queryKey => queryFnFetch<BranchAndTagCountData>(queryKey),
      type: QueryRouteQueryType.Deferred,
    },
  ],
})
